import {
  IsBoolean,
  IsDefined,
  IsInt, IsISO8601,
  IsNotEmptyObject,
  IsOptional,
  IsString,
  Length, Matches,
  ValidateNested
} from 'class-validator';
import { BillingSubscriptionPriceCreateDto } from '../billing-subscription-price';
import { Type } from 'class-transformer';

export class BillingSubscriptionCreateDto {

  @IsDefined()
  @IsString()
  @Length(0, 150)
  name: string;

  @IsDefined()
  @IsInt()
  billingProductId: number;

  @IsOptional()
  @IsInt()
  sequence: number;

  @IsOptional()
  @IsBoolean()
  isActive: boolean;

  @IsDefined()
  @IsISO8601()
  @Matches(/^\d{4}-\d{2}-\d{2}$/)
  currentDay: string;

  @IsDefined()
  @IsNotEmptyObject()
  @ValidateNested()
  @Type(() => BillingSubscriptionPriceCreateDto)
  effectivePrice: BillingSubscriptionPriceCreateDto
}